export const usePayoutValidation = (initialForm, payoutSchedule) => {
  const { payoutEndDate, payoutStartDate, scheduleDate } = initialForm;
  // const { coverageDate, schedule } = payoutSchedule;

  const payoutStartDateMessage = () => {
    if (payoutStartDate === null || payoutStartDate === "") {
      return "This field is required";
    }
    if (
      payoutSchedule?.coverageDate.from === payoutStartDate &&
      payoutSchedule?.coverageDate.to === payoutEndDate
    ) {
      return "Payout period already existing";
    }
    if (payoutStartDate >= scheduleDate) {
      return "Start Date should be later than Schedule Date.";
    }
    return null;
  };

  const payoutEndDateMessage = () => {
    if (payoutEndDate === null || payoutEndDate === "") {
      return "This field is required";
    }
    if (
      payoutSchedule?.coverageDate.from === payoutStartDate &&
      payoutSchedule?.coverageDate.to === payoutEndDate
    ) {
      return "Payout period already existing";
    }
    if (payoutEndDate <= payoutStartDate) {
      return "End Date should be later than Start Date.";
    }
    if (payoutEndDate >= scheduleDate) {
      return "End Date should be later than Schedule Date.";
    }

    return null;
  };

  const scheduleDateMessage = () => {
    if (scheduleDate === null || scheduleDate === "") {
      return "This field is required";
    }
    if (
      payoutSchedule?.coverageDate.from === payoutStartDate &&
      payoutSchedule?.coverageDate.to === payoutEndDate &&
      payoutSchedule?.schedule === scheduleDate
    ) {
      return "Payout schedule already existing";
    }

    return null;
  };

  return {
    payoutEndDate: payoutEndDateMessage(),
    payoutStartDate: payoutStartDateMessage(),
    scheduleDate: scheduleDateMessage()
  };
};

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};
